import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morphProductBlock } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * A custom element that displays product badges.
 * This component listens for variant update events and updates the badges display accordingly.
 * It handles badge updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductBadges extends Component {
  /** @type {Element | null} - Cached section/dialog the variant listener is attached to. */
  #variantUpdateTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateTarget = this.closest('.shopify-section, dialog');
    this.#variantUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadges = (event) => {
    morphProductBlock(this, event, (newBadges) => {
      this.classList.toggle('hidden', newBadges.classList.contains('hidden'));
    });
  };
}

if (!customElements.get('product-badges')) {
  customElements.define('product-badges', ProductBadges);
}
